import { Component, inject } from '@angular/core';
import { SpecieFamilyService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpecieFamilyCreateDto,
  SpecieFamilyDto,
  SpecieFamilyExcelDownloadDto,
  SpecieFamilyUpdateDto,
} from '../proxy/planning/dtos/specie-family';
import { SPECIEFAMILY_CONFIG, SPECIEFAMILY_FIELDS } from './specie-family.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-specie-family',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpecieFamilyService, ConfirmationService],
  templateUrl: './specie-family.html',
  styleUrl: './specie-family.scss',
})
export class SpecieFamily extends BaseCrudComponent<
  SpecieFamilyDto,
  SpecieFamilyCreateDto,
  SpecieFamilyUpdateDto,
  SpecieFamilyExcelDownloadDto
> {
  service = inject(SpecieFamilyService);
  config = SPECIEFAMILY_CONFIG;
  fields = SPECIEFAMILY_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpecieFamilyDto): SpecieFamilyUpdateDto {
    return {
      name: data.name,
      code: data.code,
      superiorClasificationId: data.superiorClasificationId,
      genderId: data.genderId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpecieFamily';
  }
}
